import { createSelector } from '@reduxjs/toolkit';
import { sortCreativeItems } from 'utils';

export const select_new_on_boarding_icon = (state) => {
  return state?.creatives?.selectedOnBoardIcon;
};

export const select_creatives_list = (state) => {
  return state?.creatives?.creativesList;
};

const getCreativesList = (state) => state?.creatives?.creativesList;

export const selectSortedCreativeList = createSelector([getCreativesList], (creativesList) => {
  return sortCreativeItems(creativesList);
});

export const getCountOfActiveCreatives = createSelector([getCreativesList], (creativesList) => {
  return creativesList.filter((item) => item.status === 0).length;
});

export const getMaxActiveBanners = (state) => {
  const val = parseInt(state?.creatives?.creativeAndTrackingData?.max_active_banners, 10);
  return isNaN(val) ? 5 : val;
};

export const getActiveCreativesList = createSelector([getCreativesList], (creativesList) => {
  return creativesList.filter((item) => item.status === 0);
});

export const getCountOfNotDeletedCreatives = createSelector([getCreativesList], (creativesList) => {
  return creativesList.filter((item) => item.status !== 9).length;
});

export const select_not_deleted_creatives_list = createSelector(
  [getCreativesList],
  (creativesList) => {
    return creativesList.filter((item) => item.status !== 9);
  },
);

const getCurrentCampaignObj = (state) => state?.general?.mainCampaignObject?.currentCampaignObj;
const getSelectedCreative = (state) => state.creatives.selectedCreative;

export const getCtaValueSelectedCreative = createSelector(
  [getCurrentCampaignObj, getSelectedCreative],
  (currentCampaignObj, selectedCreative) => {
    const { reEngageGoal, acquireNewUserGoal } = currentCampaignObj;
    const { cta_for_re, cta_for_ua } = selectedCreative;
    if (reEngageGoal) return { field: 'cta_for_re', value: cta_for_re };
    if (acquireNewUserGoal) return { field: 'cta_for_ua', value: cta_for_ua };
  },
);

export const getCreativeMessage = createSelector(
  [getCurrentCampaignObj, getSelectedCreative],
  (currentCampaignObj, selectedCreative) => {
    const { appDescription_existing_users, appDescription_new_users } = selectedCreative;
    const { acquireNewUserGoal, reEngageGoal } = currentCampaignObj;
    if (reEngageGoal) {
      return {
        fieldName: 'appDescription_existing_users',
        messageValue: appDescription_existing_users,
      };
    }
    if (acquireNewUserGoal) {
      return { fieldName: 'appDescription_new_users', messageValue: appDescription_new_users };
    }
  },
);
